<template>
  <div
    class="input-search d-flex align-items-center"
    :class="[{ focusing: isFocusing }, sclass, { 'is-full-width': isFullWidth }]">
    <div class="input-search__section">
      <i class="icon icon-new-search input-search-finder"></i>
      <input
        ref="search"
        v-model="txtValue"
        v-focus="autofocus"
        class="gf_input-search"
        type="text"
        :placeholder="placeholder"
        autocomplete="new-password"
        @mouseover="onHover"
        @mouseleave="onLeave"
        @focus="onFocus"
        @blur="onBlur"
        @input="onChange"
        @keyup="onKeyup" />
      <div class="actions">
        <Indicating v-if="indicating && txtValue" class="input-indicating" />
        <img v-if="searching" class="snack-loading" src="/static/icons/loading.svg" alt="" />
        <i v-if="clear && txtValue && txtValue.length" class="icon icon-clear icon-cancel" @click.stop="onClear" />
      </div>
    </div>
    <template v-if="hasSelect">
      <slot name="select"> </slot>
    </template>
  </div>
</template>

<script>
export default {
  name: 'InputSearch',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    searching: {
      type: Boolean,
      default: false,
    },
    clear: {
      type: Boolean,
      default: true,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Search for template ...',
    },
    sclass: String,
    indicating: Boolean,
    hasSelect: Boolean,
    isFullWidth: Boolean,
  },
  emits: [
    'clear',
    'onChange',
    'focus',
    'onFocus',
    'blur',
    'onHover',
    'onLeave',
    'onEnter',
    'onResize',
    'update:modelValue',
  ],
  data() {
    return {
      txtValue: '',
      runner: null,
      runnerValue: null,
      runnerResize: null,
      runnerEnter: null,

      isFocusing: false,
    };
  },
  watch: {
    modelValue(value) {
      this.txtValue = value;
    },
  },
  mounted() {
    this.txtValue = this.modelValue;

    window.addEventListener('resize', this.onResize);
  },
  onDeactivated() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    setFocus(position) {
      this.$refs.search.focus();
      this.isFocusing = true;

      if (position) {
        window.setTimeout(() => {
          this.$refs.search.setSelectionRange(position, position);
        }, 0);
      }
    },

    getOffset() {
      if (this.$refs.search) {
        return this.$refs.search.getBoundingClientRect();
      }

      return {};
    },
    onResize() {
      this.runnerResize && clearTimeout(this.runnerResize);

      this.runnerResize = setTimeout(() => {
        if (this.$refs.search) {
          const offset = this.$refs.search.getBoundingClientRect();
          this.$emit('onResize', { offset });
        }
      }, 100);
    },
    onClear() {
      this.$refs.search.focus();
      this.txtValue = '';
      this.$emit('clear', '');
      this.$emit('onChange', { value: '' });
      this.$emit('update:modelValue', '');
    },
    onFocus(e) {
      this.$emit('focus', e);
      this.isFocusing = true;
      const offset = this.$refs.search.getBoundingClientRect();
      this.$emit('onFocus', { value: this.txtValue, offset });
    },
    onBlur(e) {
      this.$emit('blur', e);
      this.isFocusing = false;
    },
    onHover() {
      this.runner && clearTimeout(this.runner);

      this.runner = setTimeout(() => {
        const offset = this.$refs.search.getBoundingClientRect();
        this.$emit('onHover', { value: this.txtValue, offset });
      }, 1);
    },
    onLeave() {
      this.runner && clearTimeout(this.runner);

      this.runner = setTimeout(() => {
        const offset = this.$refs.search.getBoundingClientRect();
        this.$emit('onLeave', { value: this.txtValue, offset });
      }, 1);
    },
    onChange() {
      // this.runnerValue && clearTimeout(this.runnerValue);
      this.$emit('update:modelValue', this.txtValue);
      // this.runnerValue = setTimeout(() => {
      const offset = this.$refs.search.getBoundingClientRect();
      const position = this.$refs.search.selectionStart;
      this.$emit('onChange', { value: this.txtValue, offset, position });
      // }, 500);
    },
    onKeyup(event) {
      this.runnerEnter && clearTimeout(this.runnerEnter);

      this.runnerEnter = setTimeout(() => {
        if (event.keyCode === 13) {
          const offset = this.$refs.search.getBoundingClientRect();
          const position = this.$refs.search.selectionStart;
          this.$emit('onEnter', { value: this.txtValue, offset, position });
        }
      }, 200);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.divider {
  border-left: 1px solid $highlight2;
  height: 16px;
}
.snack-loading {
  width: 14px;
  animation: spin 1s linear infinite;
  margin-right: 16px;
}

.icon-cancel {
  width: 14px;
  margin-right: 16px;
  color: $black2;
}

@keyframes rotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.input-search {
  display: flex;
  align-self: flex-start;
  position: relative;
  width: 100%;
  background-color: #ffffff;
  border: 1px solid transparent;
  border-radius: 3px;
  height: 40px;
  @include trans-all;
  box-sizing: border-box;

  &.is-full-width {
    input {
      width: 100%;
    }
  }
  &__section {
    position: relative;
    flex-grow: 1;
  }
  &:hover {
    border-color: $black3;
  }

  input {
    display: flex;
    padding: 12px 70px 12px 40px;
    line-height: 18px;
    border-radius: $radius;
    border: none;
    background: #ffffff;
    box-sizing: border-box !important;
    background: transparent;
    width: 100%;
    font-size: 14px;
    line-height: 16px;
    height: 16px;
    color: $text-light-high;
    @include trans-all;

    &::placeholder {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: $text-light-disabled;
    }
  }

  &-finder,
  .actions {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    font-size: 16px;
    color: #9e9e9e;
  }

  &-finder {
    left: 16px;
    color: $black2;
  }

  .actions {
    right: 0px;
    height: 100%;
    display: flex;
    align-items: center;
  }

  &-clear {
    // margin-left: 12px;
    padding: 0 16px 0 0;
    @include trans-all;

    &:hover {
      color: $mono3;
    }
  }

  &.focusing {
    border: 1px solid $mono3;
    border-radius: 3px;
    background: #ffffff;
  }
}
.input-indicating {
  // right: 42px;
  width: 40px;
  position: initial !important;
}
</style>
